module.exports = __webpack_public_path__ + "img/energy_en.897ff943.png";